

import React, { useState, useEffect } from 'react';
import './CoursesInPlace.css';
import bazeleconta from '../images/bazelecontaone.png';
import contafinanciaraone from '../images/contafinanciaraone.png';

const mockCourses = [
  { id: 1, name: 'Bazele contabilitatii', blurred: false, icon: bazeleconta, color: 'teal' },
  { id: 2, name: 'Contabilitate financiara', blurred: false, icon: contafinanciaraone, color: 'orange', inDevelopment: true },
];

export default function CoursesInPlace() {
  const [enrolledCourses, setEnrolledCourses] = useState(() => {
    const saved = localStorage.getItem('enrolledCourses');
    return saved ? JSON.parse(saved) : [1]; // Default: Bazele contabilitatii
  });

  useEffect(() => {
    localStorage.setItem('enrolledCourses', JSON.stringify(enrolledCourses));
    // Emit custom event for BCButtonWithDropdown to listen
    window.dispatchEvent(new CustomEvent('coursesUpdated', { detail: enrolledCourses }));
  }, [enrolledCourses]);

  useEffect(() => {
    // If course 2 was previously selected, fallback to course 1.
    if (enrolledCourses.includes(2)) {
      const updatedCourses = enrolledCourses.filter((id) => id !== 2);
      setEnrolledCourses(updatedCourses);
      localStorage.setItem('enrolledCourses', JSON.stringify(updatedCourses));
      localStorage.setItem('selectedCourseId', '1');
      window.dispatchEvent(new CustomEvent('courseSelected', { detail: 1 }));
      window.dispatchEvent(new CustomEvent('coursesUpdated', { detail: updatedCourses }));
    }
  }, [enrolledCourses]);

  const toggleCourseEnrollment = (courseId) => {
    localStorage.setItem('selectedCourseId', String(courseId));
    window.dispatchEvent(new CustomEvent('courseSelected', { detail: courseId }));

    if (enrolledCourses.includes(courseId)) {
      return;
    }

    const updatedCourses = [...enrolledCourses, courseId];
    setEnrolledCourses(updatedCourses);
    localStorage.setItem('enrolledCourses', JSON.stringify(updatedCourses));
    window.dispatchEvent(new CustomEvent('coursesUpdated', { detail: updatedCourses }));
  };

  return (
    <div className="coursesinplace-container">
      <div className="cursuri-title">Cursuri disponibile</div>
     
      <div className="coursesinplace-grid">
        {mockCourses.map((course) => {
          const isEnrolled = !course.inDevelopment && enrolledCourses.includes(course.id);
          const canClick = !course.blurred && !course.inDevelopment;
          const colorClass = course.color ? ` color-${course.color}` : '';
          
          return (
          <div 
            key={course.id} 
            className={`coursesinplace-card${!course.blurred ? ' current' : ''}${colorClass}`}
            onClick={() => canClick && toggleCourseEnrollment(course.id)}
            style={{ cursor: canClick ? 'pointer' : 'default' }}
          > 
            {isEnrolled && (
              <div className="coursesinplace-current-badge">
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                  <path d="M7 10L9 12L13 8" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </div>
            )}
            <div className={`coursesinplace-card-icon${!course.blurred ? ' current' : ''}${colorClass}`}>
              {course.blurred ? (
                <div className="coursesinplace-card-blur" />
              ) : (
                <img src={course.icon} alt={course.name} style={{ width: 48, height: 48, objectFit: 'contain' }} />
              )}
            </div>
            <div className={`coursesinplace-card-title${!course.blurred ? ' current' : ''}`}>
              {course.blurred ? <div className="coursesinplace-card-blur-bar" /> : course.name}
              {course.inDevelopment && <div className="coursesinplace-dev-text">Curs in dezvoltare</div>}
            </div>
          
          </div>
          );
        })}
      </div>
    </div>
  );
}
